/* eslint-disable */

export const StarEmpty = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 13" width={18} height={18} {...props}>
      <path
        fill="currentColor"
        d="M4.9 9.883 7 8.617 9.1 9.9l-.55-2.4 1.85-1.6-2.433-.217-.966-2.266-.967 2.25-2.433.216L5.45 7.5 4.9 9.883Zm-2.016 2.784 1.083-4.684-3.633-3.15 4.8-.416L7.001 0l1.866 4.417 4.8.416-3.633 3.15 1.083 4.684-4.116-2.484-4.117 2.484Z"
      />
    </svg>
  );
};
